<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="signup">
                            <ion-card-header>
                                <ion-card-title text-left color="primary">{{ $t('screens.location-region.choose') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-card v-for="region in regions" v-bind:key="region.id" class="region" @click="saveRegion(region.id)">
                                    <ion-item lines="none"><ion-thumbnail><ion-img :src="require('@/assets/' + region.img )"></ion-img></ion-thumbnail><ion-label>{{region.name}}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                                </ion-card>
                                <div class="divider"></div>
                                <ion-button size="default" color="light" class="choose" @click="notListed">{{ $t('screens.location-region.not-listed') }}</ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import axios from 'axios';

export default {
    name: 'location-region',
    data() {
        return {
            /*regions: [
                {id: 1, name: 'UK', img: require('@/assets/city-icons/lon.svg')},
                {id: 2, name: 'USA East', img: require('@/assets/city-icons/nyc.svg')},
                {id: 3, name: 'USA Midwest', img: require('@/assets/city-icons/ord.svg')},
                {id: 4, name: 'USA West', img: require('@/assets/city-icons/sfo.svg')},
                {id: 5, name: 'USA South', img: require('@/assets/city-icons/msy.svg')},
                {id: 6, name: 'Spain', img: require('@/assets/city-icons/bcn.svg')},
            ],*/
            regions: localStorage.getObject('from_regions')
        }
    },
    methods: {
        saveRegion: function(id) {
            this.$store.setSignUpRegionId(id);
            this.$router.push('/location-city');
        },
        sendMessage: function(region) {
            this.$logger.debug('signUpEmail', this.$store.state.signUp.email);
            axios.post(process.env.VUE_APP_API_VERIFY_BASE + '/not-listed',
                {
                    message: 'Could you please add the region: ' + region,
                    email: this.$store.state.signUp.email
                }
            ).then(response => {
                this.$logger.debug('data', response);
                this.$router.push('/thanks');
            }).catch((err) => {
                this.$logger.error(err);
            });
        },
        notListed: function() {
            return this.$ionic.alertController
                .create({
                    header: this.$t('screens.location-region.modal-not-listed-title'),
                    cssClass: 'ion-text-justify',
                    message: this.$t('screens.location-region.modal-not-listed-message'),
                    inputs: [
                        {
                            placeholder: this.$t('screens.location-region.modal-not-listed-placeholder'),
                            type: 'text',
                            name: 'region'
                        }],
                    buttons: [
                        {
                            text: this.$t('screens.location-region.modal-not-listed-no'),
                            role: 'cancel',
                            cssClass: 'alert-cancel-button',
                            handler: data => {
                                this.$logger.debug('cancel', data);
                            },
                        },
                        {
                            text: this.$t('screens.location-region.modal-not-listed-yes'),
                            handler: (data) => {
                                this.$logger.debug('data', data);
                                this.sendMessage(data.region);
                            },
                        },
                    ],
                })
                .then(a => a.present())
        }
    },
    beforeCreate() {
        if (!this.$store.state.signedIn && !this.$store.state.signUp.email) {
            this.$router.push('/signup')
        }
    },
}
</script>

<style>
    .alert-cancel-button  {
        color: #666 !important;
    }
</style>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg7.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
        padding-top: .5em;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-item {
        --background: rgba(255,255,255,.6);
        margin-left: 1%;
        margin-bottom: .5em;
        --min-height: 1em;
    }

    ion-button {
        margin-top: 1em;
    }

    ion-button.choose {
        margin-top: 0;
    }

    ion-label {
        font-family: 'Nunito', sans-serif;
        color: #fff;
        padding: .25em 0;
        display: block;
    }

    ion-card-header {
        --background: none;
        padding-bottom: .5em;
    }

    ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-card-title {
        --color: #333;
        font-size: 2.2em;
        font-weight: bold;
    }

    ion-col {
        padding: 0;
    }

    ion-thumbnail {
        height: 2.7em;
        width: 2.7em;
        margin: .3em .8em .3em 0em;
    }

    ion-thumbnail ion-img {
        height: 2.7em;
        object-fit: contain;
    }

    ion-button ion-icon {
        margin-right: .5em;
    }

    .region {
        padding: 0;
        margin-bottom: 0;
    }

    .region ion-item {
        --inner-padding-end: .5em;
        --padding-start: .5em;
        margin: 0;
        cursor: pointer;
    }

    .region:hover {
        background-color: #ffccdd;
    }

    .region ion-label {
        color: #666;
        font-size: 1em;
        margin: 0;
    }

    .region ion-icon {
        margin: 0;
    }

    .region .arrow {
        margin-left: .5em;
    }

    .divider {
        margin: .2em auto;
    }
</style>